// import router from '@/router'
// import store from '@/store'
import { CustomizeInterceptor } from '@/types/axios/interceptor'
import { NormalizedError } from '@/types/axios/public-json-structure'
// import { openAuthFailMsgBox } from '@/utils/message'
import { Message } from 'element-ui'

const interceptor: CustomizeInterceptor<any, Promise<never>> = {
  fulfilled: undefined,
  rejected: (error: NormalizedError) => {
    if (error.errorType === 'axios' && error.httpStatus === 403) {
      Message.closeAll()
      Message({ type: 'error', message: '无访问权限，请联系管理员!' })
      return Promise.reject()
    }
    // 单独处理401的情况
    // TODO: 代码较为耦合，后期应当进行调整，例如放入单独的拦截器中
    // TODO: 部分系统中具有refresh-token这个概念
    if (error.errorType === 'axios' && error.httpStatus === 401) {
      Message.closeAll()
      // openAuthFailMsgBox()
      // 北师大版本：当请求401时，说明登录状态过期，需跳转至响应结果中的网址
      const url = error.axiosError.response?.data.data
      if (url) {
        Message({ type: 'error', message: '未登录，正在跳转登录页...' })
        window.location.replace(url)
      }
      error.messageHasShown = true
      // TODO: 假设这里提示错误信息，如果业务里try...catch的catch逻辑中也进行了报错，那么很可能导致多次报错
      return Promise.reject(error)
    }

    // 是否展示报错信息标识
    let shouldShowMessage = true
    if (error.errorType === 'axios' && error.axiosError?.config) {
      shouldShowMessage =
        'showMessageOnError' in error.axiosError.config
          ? !!error.axiosError.config.showMessageOnError
          : true
    } else if (error.errorType === 'cancel') {
      shouldShowMessage = false
    } else if (error.errorType === 'custom') {
      shouldShowMessage =
        'showMessageOnError' in error.axiosRes.config
          ? !!error.axiosRes.config.showMessageOnError
          : true
    }

    if (shouldShowMessage) {
      error.messageHasShown = true
      Message.error(error.message)
    }

    return Promise.reject(error)
  }
}

export default interceptor
